export type FontDefinition = {
  name: string;
  title: string;
  type: "sans" | "mono" | "serif";
  family: string;
  registryVariable: "--font-sans" | "--font-mono" | "--font-serif";
  previewVariable: string;
  provider: "google";
  import: string;
  dependency: string;
  subsets: readonly string[];
  weight?: readonly string[];
};

export const FONT_DEFINITIONS = [
  {
    dependency: "@fontsource-variable/geist",
    family: "'Geist Variable', sans-serif",
    import: "Geist",
    name: "geist",
    previewVariable: "--font-geist-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Geist",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/inter",
    family: "'Inter Variable', sans-serif",
    import: "Inter",
    name: "inter",
    previewVariable: "--font-inter",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Inter",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/noto-sans",
    family: "'Noto Sans Variable', sans-serif",
    import: "Noto_Sans",
    name: "noto-sans",
    previewVariable: "--font-noto-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Noto Sans",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/nunito-sans",
    family: "'Nunito Sans Variable', sans-serif",
    import: "Nunito_Sans",
    name: "nunito-sans",
    previewVariable: "--font-nunito-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Nunito Sans",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/figtree",
    family: "'Figtree Variable', sans-serif",
    import: "Figtree",
    name: "figtree",
    previewVariable: "--font-figtree",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Figtree",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/roboto",
    family: "'Roboto Variable', sans-serif",
    import: "Roboto",
    name: "roboto",
    previewVariable: "--font-roboto",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Roboto",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/raleway",
    family: "'Raleway Variable', sans-serif",
    import: "Raleway",
    name: "raleway",
    previewVariable: "--font-raleway",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Raleway",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/dm-sans",
    family: "'DM Sans Variable', sans-serif",
    import: "DM_Sans",
    name: "dm-sans",
    previewVariable: "--font-dm-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "DM Sans",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/public-sans",
    family: "'Public Sans Variable', sans-serif",
    import: "Public_Sans",
    name: "public-sans",
    previewVariable: "--font-public-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Public Sans",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/outfit",
    family: "'Outfit Variable', sans-serif",
    import: "Outfit",
    name: "outfit",
    previewVariable: "--font-outfit",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Outfit",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/oxanium",
    family: "'Oxanium Variable', sans-serif",
    import: "Oxanium",
    name: "oxanium",
    previewVariable: "--font-oxanium",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Oxanium",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/manrope",
    family: "'Manrope Variable', sans-serif",
    import: "Manrope",
    name: "manrope",
    previewVariable: "--font-manrope",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Manrope",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/space-grotesk",
    family: "'Space Grotesk Variable', sans-serif",
    import: "Space_Grotesk",
    name: "space-grotesk",
    previewVariable: "--font-space-grotesk",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Space Grotesk",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/montserrat",
    family: "'Montserrat Variable', sans-serif",
    import: "Montserrat",
    name: "montserrat",
    previewVariable: "--font-montserrat",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Montserrat",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/ibm-plex-sans",
    family: "'IBM Plex Sans Variable', sans-serif",
    import: "IBM_Plex_Sans",
    name: "ibm-plex-sans",
    previewVariable: "--font-ibm-plex-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "IBM Plex Sans",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/source-sans-3",
    family: "'Source Sans 3 Variable', sans-serif",
    import: "Source_Sans_3",
    name: "source-sans-3",
    previewVariable: "--font-source-sans-3",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Source Sans 3",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/instrument-sans",
    family: "'Instrument Sans Variable', sans-serif",
    import: "Instrument_Sans",
    name: "instrument-sans",
    previewVariable: "--font-instrument-sans",
    provider: "google",
    registryVariable: "--font-sans",
    subsets: ["latin"],
    title: "Instrument Sans",
    type: "sans",
  },
  {
    dependency: "@fontsource-variable/jetbrains-mono",
    family: "'JetBrains Mono Variable', monospace",
    import: "JetBrains_Mono",
    name: "jetbrains-mono",
    previewVariable: "--font-jetbrains-mono",
    provider: "google",
    registryVariable: "--font-mono",
    subsets: ["latin"],
    title: "JetBrains Mono",
    type: "mono",
  },
  {
    dependency: "@fontsource-variable/geist-mono",
    family: "'Geist Mono Variable', monospace",
    import: "Geist_Mono",
    name: "geist-mono",
    previewVariable: "--font-geist-mono",
    provider: "google",
    registryVariable: "--font-mono",
    subsets: ["latin"],
    title: "Geist Mono",
    type: "mono",
  },
  {
    dependency: "@fontsource-variable/noto-serif",
    family: "'Noto Serif Variable', serif",
    import: "Noto_Serif",
    name: "noto-serif",
    previewVariable: "--font-noto-serif",
    provider: "google",
    registryVariable: "--font-serif",
    subsets: ["latin"],
    title: "Noto Serif",
    type: "serif",
  },
  {
    dependency: "@fontsource-variable/roboto-slab",
    family: "'Roboto Slab Variable', serif",
    import: "Roboto_Slab",
    name: "roboto-slab",
    previewVariable: "--font-roboto-slab",
    provider: "google",
    registryVariable: "--font-serif",
    subsets: ["latin"],
    title: "Roboto Slab",
    type: "serif",
  },
  {
    dependency: "@fontsource-variable/merriweather",
    family: "'Merriweather Variable', serif",
    import: "Merriweather",
    name: "merriweather",
    previewVariable: "--font-merriweather",
    provider: "google",
    registryVariable: "--font-serif",
    subsets: ["latin"],
    title: "Merriweather",
    type: "serif",
  },
  {
    dependency: "@fontsource-variable/lora",
    family: "'Lora Variable', serif",
    import: "Lora",
    name: "lora",
    previewVariable: "--font-lora",
    provider: "google",
    registryVariable: "--font-serif",
    subsets: ["latin"],
    title: "Lora",
    type: "serif",
  },
  {
    dependency: "@fontsource-variable/playfair-display",
    family: "'Playfair Display Variable', serif",
    import: "Playfair_Display",
    name: "playfair-display",
    previewVariable: "--font-playfair-display",
    provider: "google",
    registryVariable: "--font-serif",
    subsets: ["latin"],
    title: "Playfair Display",
    type: "serif",
  },
] as const satisfies readonly FontDefinition[];

export type FontName = (typeof FONT_DEFINITIONS)[number]["name"];
